"use client";

import React from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HopeBeginsWithBasket() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227202" id="expertise-in-immigrazione" className="relative dark bg-background overflow-hidden py-20 md:py-28 lg:py-36">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_global_pattern.png)] bg-repeat" aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out transform ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <div className="space-y-6">
              <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold text-accent leading-[1.1] tracking-tighter">
                Professionalità e Precisione
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground max-w-lg leading-relaxed font-default">
                Assistenza professionale per richieste di visto, pratiche di immigrazione e mobilità internazionale, con supporto dedicato per aziende, studenti, famiglie e privati. Gestione documentale, consulenza personalizzata e accompagnamento nelle procedure consolari e amministrative internazionali.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button variant="outline" size="lg" className="text-base h-14 px-8 gap-3 bg-[#FFC829] border-none hover:bg-[#FFC829]/90 transition-all text-black" asChild>
                <Link to="/ContactsPage">
                  <span className="flex items-center justify-center w-6 h-6 rounded-lg bg-black/10 text-black">
                    <Play className="w-3 h-3 fill-current" />
                  </span>
                  <span className="opacity-100 text-accent">Consulenza Diretta</span>
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`relative transition-all duration-1000 ease-out delay-200 transform ${isImgVisible ? "translate-x-0 opacity-100" : "translate-x-12 opacity-0"}`}>
            {}
            <div className="absolute -bottom-8 -left-8 w-48 h-48 bg-primary/20 rounded-lg blur-3xl opacity-60 -z-10" />
            <div className="absolute -top-8 -right-8 w-64 h-64 bg-primary/10 rounded-lg blur-3xl opacity-60 -z-10" />

            <div className="relative overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square lg:aspect-[4/5] bg-muted border border-primary/20">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/premium_corporate_office_interior.png" alt="Ufficio legale internazionale di alto livello" className="w-full h-full object-cover" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-background/20 mix-blend-multiply pointer-events-none" />
              <div className="absolute inset-0 bg-gradient-to-r from-background/40 via-transparent to-transparent mix-blend-multiply pointer-events-none" />
              
              {}
              <div className="absolute inset-0 border border-primary/20 pointer-events-none" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}